import { Injectable, OnDestroy } from '@angular/core';
import { AuthHTTPService } from './auth-http';
import { ImpersonateInput, ImpersonateOutput } from '../models/impersonation.model';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Subject, takeUntil } from 'rxjs';

@Injectable({
    providedIn: 'root',
  })
export class ImpersonationService implements OnDestroy {

  protected _onDestroy = new Subject();
  constructor(
      private httpService: AuthHTTPService,
      private authService: AuthService
  ) { }

  impersonate(userId: number, tenantId?: number): void {
    const input = new ImpersonateInput(tenantId, userId);
    input.userId = userId;
    input.tenantId = tenantId;

    this.httpService.impersonate(input)
        .subscribe((result: ImpersonateOutput) => {
            this.authService.logout(false).pipe(takeUntil(this._onDestroy)).subscribe();
            let baseUrl = this.getImpersonationUrl(input.tenantId);
            let targetUrl = baseUrl + '?impersonationToken=' + result.impersonationToken;
            if (input.tenantId) {
                targetUrl = targetUrl + '&tenantId=' + input.tenantId;

            }

            window.location.href = targetUrl;
        });
  }

  backToImpersonator(): void {
    this.httpService.backToImpersonator()
        .subscribe((result: ImpersonateOutput) => {
            this.authService.logout(false).pipe(takeUntil(this._onDestroy)).subscribe();
            let targetUrl = this.getImpersonationUrl(undefined) + '?impersonationToken=' + result.impersonationToken;
            //TO DO: Add Tenant Id 
            // if (abp.session.impersonatorTenantId) {
            //     targetUrl = targetUrl + '&tenantId=' + abp.session.impersonatorTenantId;
            // }

            location.href = targetUrl;
        });
  }

  getImpersonationUrl(tenantId: number | undefined): string {
    if (tenantId !== undefined) {
        return environment.customerPortalUrl;
    }

    return environment.appBaseUrl;
  }

  ngOnDestroy() {
    this._onDestroy.complete();
  }
}

